export default (renderType: string, defaultValue: string): string => {
  return ['editorial', 'dynamic', 'fte'].indexOf(renderType) >= 0 ? renderType : defaultValue;
};
